export default "__VITE_ASSET__DipcPn8v__"